// src/pages/countries/EditCountries.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCountries from "../../components/countries/FormAddEditCountries";
import useGetCountry from "../../hooks/countries/useGetCountry";
import LoadingPage from "../../components/global/LoadingPage";

const EditCountries = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, country } = useGetCountry(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/countries");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCountries
                isEdit={true}
                currentData={country}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditCountries;
